// extracted by mini-css-extract-plugin
module.exports = {"flight":"flight-1-H3h"};